import React from "react";
import { Box, TableRow, TableCell } from "@material-ui/core";

export default function EmptyTopic() {
  return (
    <TableRow style={{ height: "140px" }}>
      <TableCell>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
          height="140px"
          boxSizing={"border-box"}
        >
          <Box width="90%"></Box>
        </Box>
      </TableCell>
    </TableRow>
  );
}
